import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CorrectRouteGuard {
    constructor() {}

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = `/${route?.url.map((u) => u.path).join('/')}`;
        return !url?.match(/\/([0-9a-zA-Z-_]+)\/(?:\1)(\/|$)/);
    }
}
